import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Form, FormikProps} from "formik";

import {Form as BootstrapForm} from "react-bootstrap";
import {
  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS,
  isSearchingForProductId,
  isUpdateResultsSearchAvailable,
} from "../../../../helpers/configurationHelper";
import DynamicSearchFieldsList from "../../../shared/dynamic-form/DynamicSearchFieldsList";
import DynamicHeaderForm from "../../../shared/dynamic-form/DynamicHeaderForm";
import ModeField from "../../../shared/fields/ModeField";
import SearchModeField from "../../../shared/fields/SearchModeField";
import DateFields from "../../../shared/fields/DateFields";
import MissionField from "../../../shared/fields/MissionField";
import SearchButtons from "../../../shared/buttons/SearchButtons";
import {AdvancedSearchConfigurationsType} from "../../../../types/configurations";
import {ShapeType} from "../../../../types/shape";
import {ProductImageStacType} from "../../../../types/product";
import InterferometricStackField from "../../../shared/fields/InterferometricStackField";
import {
  resetProductionFiltersSelectedAction,
  resetSearchFiltersSelectedAction,
} from "../../../../state/application/actions";
import {AppParametersType} from "../../../../types/app";
import translations from "../../../../translations";
import InputTextArea from "../../../shared/inputs/InputTextArea";
import {setSearchProductIds} from "../../../../state/geoMap/actions";

interface PropsType {
    mainInputConfigurations: any;
    configurations: AdvancedSearchConfigurationsType;
    lastShape: ShapeType;
    selectedProducts: ProductImageStacType[];
    loadingInitialData: boolean;
    formProps: FormikProps<any>;
    resetSearchFiltersSelectedActionHandler: any;
    resetProductionFiltersSelectedActionHandler: any;
    appParameters: AppParametersType;
    language: string;
    updateFormDataPayloadActionHandler: any;
    formData: any;
    setSearchProductIdsHandler: any;
    setSearchMode: any;
}

const SatelliteImageryForm = (props: PropsType) => {
  const {
    mainInputConfigurations,
    configurations,
    lastShape,
    selectedProducts,
    formProps: originFormProps,
    resetSearchFiltersSelectedActionHandler,
    resetProductionFiltersSelectedActionHandler,
    appParameters,
    language,
    setSearchProductIdsHandler
  } = props;

  const formProps = {
    ...originFormProps,
    resetForm: () => {
      if (!isSearchingForProductId(values)) {
        originFormProps.resetForm();
        resetSearchFiltersSelectedActionHandler();
        resetProductionFiltersSelectedActionHandler();
      } else {
        setFieldValue("product_id", "");
        setSearchProductIdsHandler("");
      }
    },
  };

  let {values, setFieldValue} = formProps;
  const [jsonAoi, setJsonAoi] = useState({});
  const arch1 = values.routine;

  useEffect(() => {
    const obj = {};
    if (lastShape != null) {
      if (
        lastShape.layerType === "rectangle" ||
                lastShape.layerType === "polygon"
      ) {
        const objPolygon = {
          storefront: "DefaultStore",
          km2: `${Math.round(Math.floor(lastShape.area / 1000000) * 10) / 10}.0`,
          items: [],
          polygon: lastShape.layer,
        };

        setJsonAoi(objPolygon);
      }
      if (
        lastShape.layerType === "circle" &&
                lastShape.hasOwnProperty("circle_center") &&
                lastShape.hasOwnProperty("circle_radius")
      ) {
        // @mapitaly: rimossi questi parametri che probabilmente non servono

        const objCircle = {
          storefront: "DefaultStore",
          km2: `${Math.round(Math.floor(lastShape.area / 1000000) * 10) / 10}.0`,
          items: [],
          circle: {
            radius: lastShape.circle_radius,
            center: lastShape.circle_center,
          },
        };
        setJsonAoi(objCircle);
      }
    }
  }, [lastShape]);

  return (
    <Form className="filters-form">
      <div className="inner-content">
        <h6 className="title-like border-bottom section-title m-0 p-3">
          {translations("filtersLeftSearchBar", language)}
        </h6>
        <div className="p-3">
          <ModeField
            scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
            formProps={formProps}
            disabled={isUpdateResultsSearchAvailable(
              configurations, appParameters,
              values,
              selectedProducts
            )}
          />

          <SearchModeField
            scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
            formProps={formProps}
          />

          <MissionField
            mainInputConfigurations={mainInputConfigurations}
            scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
            formProps={formProps}
            disabled={isUpdateResultsSearchAvailable(
              configurations, appParameters,
              values,
              selectedProducts
            )}
          />

          {// !isSearchingForProductId(values) &&
            (
              <>
                <DateFields
                  configurations={configurations}
                  mainInputConfigurations={mainInputConfigurations}
                  scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
                  selectedArea={lastShape}
                  selectedProducts={selectedProducts}
                  formProps={formProps}
                  appParameters={appParameters}
                />
              </>
            )
          }

          {// !isSearchingForProductId(values) &&
            (!isSearchingForProductId(values) || !values.routine) && (
              <InterferometricStackField
                configurations={configurations}
                scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
                formProps={formProps}
                disabled={isUpdateResultsSearchAvailable(
                  configurations, appParameters,
                  values,
                  selectedProducts
                )}
              />
            )
          }

          {isSearchingForProductId(values) && (
            <div className="row mx-0 mb-3">
              <BootstrapForm.Label className="m-0 px-0 d-flex col-3">
                <span>
                  *
                  {arch1 ? translations("tileIds", language) : translations("recordNumbers", language)}
                </span>
              </BootstrapForm.Label>
              <BootstrapForm.Group className="m-0 pr-0 col-9">
                <InputTextArea
                  key={`satellite-imagery-advanced-filters-${values.missions[0]}`}
                  name="product-id"
                  placeholder={arch1 ?
                    translations(
                      "tileIdsPlaceholder", language
                    ) :
                    translations(
                      "recordNumberPlaceholder",
                      language
                    )}
                  onChange={
                    (e) => {
                      values = e.target.value;
                      setFieldValue("product_id", values);
                      const listValues = values.trim().split(",");
                      const productIds = listValues
                        ?.map((str: string) => str.trim())
                        .filter((str: string) => str !== "0");
                      setSearchProductIdsHandler(productIds);
                      // console.log("productIds", productIds);
                    }
                  }
                  defaultValue=""
                  disabled={false}

                />
              </BootstrapForm.Group>
            </div>
          )}

          {!isSearchingForProductId(values) &&
                        values.missions.length === 1
                        && (
                          <>
                            <DynamicHeaderForm
                              title={translations(
                                "advancedFiltersLeftSearchBar",
                                language
                              )}
                            />
                            <DynamicSearchFieldsList
                              key={`satellite-imagery-advanced-filters-${values.missions[0]}`}
                              configurations={configurations}
                              scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
                              selectedArea={lastShape}
                              selectedProducts={selectedProducts}
                              formProps={formProps}
                              appParameters={appParameters}
                            />
                          </>
                        )}
          {/* @mapitaly: se c'è il multimission devo mostrare i filtri in comune */}
          {!isSearchingForProductId(values) &&
                        values.missions.length > 1
                        && (
                          <>
                            <DynamicHeaderForm
                              title={translations(
                                "advancedFiltersLeftSearchBar",
                                language
                              )}
                            />
                            <DynamicSearchFieldsList
                              key="satellite-imagery-advanced-filters-all-missions"
                              configurations={configurations}
                              scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
                              selectedArea={lastShape}
                              selectedProducts={selectedProducts}
                              formProps={formProps}
                              appParameters={appParameters}
                            />
                          </>
                        )}
        </div>
      </div>
      <SearchButtons
        mainInputConfigurations={mainInputConfigurations}
        configurations={configurations}
        scopeConfigurationFields={SCOPE_CONFIGURATION_FIELDS}
        selectedArea={lastShape}
        formProps={formProps}
        selectedProducts={selectedProducts}
        appParameters={appParameters}
      />
    </Form>
  );
};

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  language: state.application.appParameters.language,

});

const mapDispatchToProps = (dispatch, ownProps) => ({
  resetSearchFiltersSelectedActionHandler: () => dispatch(resetSearchFiltersSelectedAction()),
  resetProductionFiltersSelectedActionHandler: () => dispatch(resetProductionFiltersSelectedAction()),
  setSearchProductIdsHandler: (productIds) => {
    // console.log("setSearchProductIdsHandler", productIds);
    return dispatch(setSearchProductIds(productIds));
  },
  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SatelliteImageryForm);
